<template>
  <icon-svg-base :class="$style.icon" :view-width="20" :view-height="20">
    <circle :class="$style.icon__circle" r="10" cx="10" cy="10" />
    <path
      :class="$style.icon__question"
      d="M8.8,12h2c-0.2-2.3,2.5-3,2.5-5.3c0-2-1.4-3-3.3-3c-1.4,0-2.5,0.7-3.4,1.6L8,6.5C8.5,6,9,5.6,9.7,5.6c0.8,0,1.4,0.5,1.4,1.3C11.1,8.4,8.4,9.5,8.8,12zM9.8,16.3c0.8,0,1.5-0.7,1.5-1.5c0-0.9-0.6-1.5-1.5-1.5c-0.8,0-1.5,0.7-1.5,1.5C8.3,15.6,8.9,16.3,9.8,16.3z"
    />
  </icon-svg-base>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IconSvgBase from '@/components/icons/IconSvgBase.vue'

export default defineComponent({
  name: 'IconQuestion',
  components: {
    IconSvgBase,
  },
})
</script>

<style lang="scss" module>
.icon {
  width: 1em;
  height: 1em;

  &__question {
    fill: $color-text-and-object-high-emphasis-inverse;
  }

  &__circle {
    fill: currentcolor;
  }
}
</style>
